export const permissionRules = {

  'default': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': true,
    'influencer': true,
    'analyst': true
  },

  'main_menu.enable_home': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': true,
    'influencer': true,
    'analyst': false
  },

  'main_menu.enable_discover': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'main_menu.enable_measure': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': true,
    'influencer': false,
    'analyst': false
  },

  'main_menu.enable_groups': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'main_menu.enable_campaigns': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_managing': {
    'admin': true,
    'advertiser': false,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_projects': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_preferred': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_channels': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': true,
    'analyst': false
  },

  'menu.enable_networks': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': true,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_groups': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'menu.enable_campaigns': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'user_menu.enable_user_settings': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': true,
    'influencer': false,
    'analyst': true
  },

  'user_menu.enable_influencer_settings': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': true,
    'analyst': false
  },

  'user_menu.enable_billing': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': true
  },

  'user_menu.enable_manage_channels': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': true,
    'analyst': false
  },

  'user_menu.enable_manage_influencer': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': true,
    'influencer': false,
    'analyst': false
  },

  'user_menu.enable_admin': {
    'admin': true,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': false,
    'analyst': true
  },

  'user_menu.enable_change_account': {
    'admin': true,
    'advertiser': false,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'main_menu.enable_inbox': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'discover.enable_advanced_preferred_options': {
    'admin': true,
    'advertiser': false,
    'agency': true,
    'network': true,
    'influencer': true,
    'analyst': false
  },

  'discover.enable_advanced_group_options': {
    'admin': true,
    'advertiser': true,
    'agency': true,
    'network': false,
    'influencer': false,
    'analyst': false
  },

  'influencer_platform.enable_influencer_details': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': true,
    'analyst': false
  },

  'influencer_platform.enable_influencer_campaigns': {
    'admin': false,
    'advertiser': false,
    'agency': false,
    'network': false,
    'influencer': true,
    'analyst': false
  }
};



// WEBPACK FOOTER //
// ./src/permissions-rules.ts